export default class AutoSubmit {
  constructor() {
    N2.bindHandler('click', '.form-auto-submit', function(evt) {
      $(this).closest('form').submit();
    });
  }
}
